import cn from 'classnames';
import { useEffect, useState } from 'react';

import ArrowScrollToTop from '../SVGIcons/ArrowScrollToTop';
import classes from './scroll-to-top.module.scss';

interface IScrollToTopProps {
  showPosition: number;
}

function ScrollToTop({ showPosition }: IScrollToTopProps) {
  const [scrollPosition, setScrollPosition] = useState(0);

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      className={cn({
        [classes.button]: true,
        [classes.hidden]: !(scrollPosition > showPosition),
        [classes.shown]: scrollPosition > showPosition,
      })}
      role="none"
      onClick={handleClick}
    >
      <ArrowScrollToTop />
    </div>
  );
}

export default ScrollToTop;
